import React, { useEffect } from 'react';
import Game from './screens/Game';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './common/theme';
import { auth } from 'common/firebase';
import { BrowserRouter } from 'react-router-dom';
const App = () => {
  useEffect(() => {
    auth.onAuthStateChanged(user => {
      if (user) {
        if (user.email === 'admin@baac.com') {
          auth.signOut();
        }
      }
    });
  }, []);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Game />
      </ThemeProvider>
    </BrowserRouter>
  );
};
export default App;
